import { count } from "sms-length";

type SmsEncoding = "GSM_7BIT" | "UTF16";

interface SmsPartsResult {
  encoding: SmsEncoding;
  parts: number;
  length: number;
  remaining: number;
  per_message: number;
}

export const getSmsPartsCount = (text: string): SmsPartsResult => {
  const result = count(text);

  return {
    encoding: result.encoding as SmsEncoding,
    parts: result.messages,
    length: result.length,
    remaining: result.remaining,
    per_message: result.characterPerMessage,
  };
};
